import {useEffect, useState} from 'react';
import {functionalitiesAliasMap} from '../../util/strings';

export const useWindowWidth = () => {
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);

  useEffect(() => {
    const handleResize = () => setWindowWidth(window.innerWidth);
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return windowWidth;
};

export const useIsLanguageActive = (buDefaultFunctionalities: any) => {
  const [isActive, setIsActive] = useState(true);

  useEffect(() => {
    const feature = buDefaultFunctionalities?.funcionalidade?.find(
      (el: any) =>
        el?.featureTemplateAlias === functionalitiesAliasMap.multiLanguage
    );
    setIsActive(feature?.isVisible);
  }, [buDefaultFunctionalities]);

  return isActive;
};
export const useAreNotificationsActive = (buDefaultFunctionalities: any) => {
  const [isActive, setIsActive] = useState(true);

  useEffect(() => {
    //we need to create the new feature in BO and decide the logic to show it, for now, as it is not implemented, will return false
    // const feature = buDefaultFunctionalities?.funcionalidade?.find(
    //   (el: any) =>
    //     el?.featureTemplateAlias === functionalitiesAliasMap.generalMessages
    // );
    // setIsActive(feature?.isVisible);
    setIsActive(false);
  }, [buDefaultFunctionalities]);

  return isActive;
};
